import { render, staticRenderFns } from "./ModalProvider.vue?vue&type=template&id=60b10370&scoped=true"
import script from "./ModalProvider.vue?vue&type=script&lang=js"
export * from "./ModalProvider.vue?vue&type=script&lang=js"
import style0 from "./ModalProvider.vue?vue&type=style&index=0&id=60b10370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b10370",
  null
  
)

export default component.exports